export enum PaymentType {
  Check,
  'Direct Deposit',
  'Wire Transfer',
  'Internal Payment',
}
